module.exports = __webpack_public_path__ + "static/media/All_Services.feccbcf6.svg";